import { useTranslation } from 'react-i18next';
import { MenuItem, TextField, Autocomplete, classes, styled } from 'bonfire-kindling';
import { canadianProvinces, americanStates } from 'constants/regions';
const optionsGrouped = {
  US: americanStates.map(({ label }) => label),
  Canada: canadianProvinces.map(({ label }) => label),
};
const StyledTextField = styled(TextField)(({ theme }) => ({
  [`& .${classes.components.MuiInput.root}`]: {
    paddingBottom: 0,
    [`& .${classes.components.MuiInput.input}`]: {
      padding: `0.4rem ${theme.spacing(2)}`,
    },
  },
}));

const SubregionAutocomplete = ({ onChange, value, name, country }) => {
  const { t } = useTranslation();
  const options = optionsGrouped[country] ?? [];

  return (
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={option => option}
      onInputChange={(_, value) => onChange({ target: { value, name } })}
      onChange={(_, value) => onChange({ target: { value, name } })}
      renderOption={(props, option) => <MenuItem {...props} label={option} />}
      renderInput={params => (
        <StyledTextField
          {...params}
          inputProps={{
            ...params.inputProps,
            value,
          }}
          maxLength={256}
          fullWidth
          margin="dense"
          label={t('settings.business.region')}
        />
      )}
    />
  );
};

export default SubregionAutocomplete;
